<icz-own-consignment-table
  tableTitle="Vyvěšení"
  [document]="document"
  [tableView]="tableView"
></icz-own-consignment-table>
